export default {
  data() {
    return {
      baseUrl: process.env.RESOURCES_URI,
      monthStr: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: {
    coverFolder(el) {
      let yy = el.year.substring(2);
      let mm = ("0" + (el.month + 1)).slice(-2);
      let dd = ("0" + el.day).slice(-2);
      return yy + mm + dd;
    },
    imageLoadError(event) {
      event.target.src = require("@/assets/image-not-available-3.jpg");
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  },
  computed: {
    eventCover() {
      return (event) => {
        let d = new Date(event.startDate);
        let yy = ("" + d.getFullYear()).substring(2);
        let mm = ("0" + (d.getMonth() + 1)).slice(-2);
        let dd = ("0" + d.getDate()).slice(-2);
        return `${this.baseUrl}/events/${yy}${mm}${dd}/${event.cover}`;
      }
    },
    cover() {
      return (sermon, slideNo) => {
        let folder = this.coverFolder(sermon);
        return `${this.baseUrl}/sermons/${folder}/slides/Slide${slideNo}.jpg`;
      };
    },
    slide() {
      return (sermon, slide) => {
        let folder = this.coverFolder(sermon);
        return `${this.baseUrl}/sermons/${folder}/slides/${slide}`;
      };
    },
    date() {
      return sermon =>
        `${this.monthStr[sermon.month]} ${sermon.day}, ${sermon.year}`;
    },
    eventDate() {
      return (start, end) => {
        let startDate = new Date(start);
        let endDate = new Date(end);
        var options = {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          timeZone: "UTC"
        };
        if (startDate.getUTCDate() == endDate.getUTCDate()) {
          // return `${this.monthStr[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()}`
          return startDate.toLocaleString("en", options);
        } else {
          // return `${this.monthStr[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()} -
          //${this.monthStr[endDate.getUTCMonth()]} ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`
          options.hour = "numeric";
          options.minute = "numeric";
          return startDate.toLocaleString("en", options);
        }
      };
    },
    eventTime() {
      return (start, end) => {
        let startDate = new Date(start);
        let endDate = new Date(end);
        if (startDate.getUTCDate() == endDate.getUTCDate()) {
          var options = { hour: "numeric", minute: "numeric" };
          return (
            startDate.toLocaleString("en", options) +
            " - " +
            endDate.toLocaleString("en", options)
          );
        } else {
          var options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            timeZone: "UTC"
          };
          return endDate.toLocaleString("en", options);
        }
      };
      // return date => {
      //   let d = new Date(date);
      //   let ampm = d.getUTCHours() < 12 ? "am" : "pm";
      //   let hh = d.getUTCHours() % 12;
      //   hh = hh ? hh : 12;
      //   let mn = ("0" + d.getUTCMinutes()).slice(-2);
      //   console.log(d.getUTCHours() + ":" + d.getUTCMinutes());
      //   return `${hh}:${mn}${ampm}`
      // }
    },
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '220px'
        case 'sm': return '400px'
        case 'md': return '500px'
        case 'lg': return '660px'
        case 'xl': return '800px'
      }
    },
    carouselHeight() {
      let ratio = 0.3;
      let height = this.window.width * ratio;
      return height;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/imageMixin.js